import {createReducer} from "@reduxjs/toolkit";
import {SpeakersActions} from "./speakers.action";

const initialState = {
  loading: false,
  error: false,
  list: []
};

export const SpeakersReducer = {
  speakers: createReducer(initialState, (builder => {
    builder
      .addCase(SpeakersActions.fetchList.pending, (state, _) => {
        console.log('[SpeakersActions.fetchList.pending]: ')

        return {
          ...state,
          loading: true,
          error: false
        }
      })
      .addCase(SpeakersActions.fetchList.rejected, (state, _) => {
        console.log('[SpeakersActions.fetchList.rejected]: ')
        return {
          ...state,
          loading: false,
          error: true
        }
      })
      .addCase(SpeakersActions.fetchList.fulfilled, (state, {payload}) => {
        console.log('[SpeakersActions.fetchList.fulfilled]: ', payload)

        return {
          ...state,
          list: payload,
          loading: false,
          error: false,
        }
      })
  }))
}
